// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type IndexedPageView from "../contract/IndexedPageView";

export default function indexedPageView(data: IndexedPageView): IndexedPageView {
    const result: IndexedPageView = {
        __type: "IndexedPageView:#Exchange",
        ...data,
    };
    
    return result;
}
